/** Target UX durations — keep in sync with backend generation profiles. */
export const PORTRAIT_GENERATION_SECONDS = 12;
export const IMAGE_GENERATION_SECONDS = 20;
export const VIDEO_GENERATION_SECONDS = 30;
